import { MouseEvent, useId, useMemo } from 'react';
import { Icon, IconName, Tab, TabGroup, Tooltip } from '@carbonify/ui';
import clsx from 'clsx';
import { notEmpty } from 'utils/arrays';

import styles from './ProductsModule.module.css';

const mapVehicleClassToIcon: Record<string, IconName> = {
  M1: 'car',
  Andere: 'motorcycle',
  N1: 'van',
  N2: 'pickup',
  N3: 'truck',
  M3: 'bus',
};

interface Props {
  options: string[];
  onChange: (newVehicleClass: string) => void;
  value?: string;
  className?: string;
}

export default function VehicleClassSelector({ options, value, onChange, className }: Props) {
  const id = useId();
  const vehicleClasses = useMemo(
    () =>
      Object.entries(mapVehicleClassToIcon)
        .map(([vehicleClass, icon]) => (options.includes(vehicleClass) ? { vehicleClass, icon } : undefined))
        .filter(notEmpty),
    [options],
  );

  const handleTabClick = ({ currentTarget }: MouseEvent<HTMLButtonElement>) => {
    const vehicleClass = currentTarget.getAttribute('data-class');
    if (vehicleClass) onChange(vehicleClass);
  };

  return (
    <div className={clsx(className)}>
      <label
        className={styles.vehicleClassLabel}
        htmlFor={id}
      >
        Du hast ein anderes Fahrzeug?
      </label>
      <TabGroup id={id}>
        {vehicleClasses.map(({ vehicleClass, icon }) => (
          <Tooltip
            key={vehicleClass}
            label={`Fahrzeugklasse: ${vehicleClass}`}
            placement="top"
          >
            <Tab
              active={vehicleClass === value}
              iconOnly
              data-class={vehicleClass}
              onClick={handleTabClick}
            >
              <Icon
                name={icon}
                aria-label={vehicleClass}
                className={styles.vehicleClassIcon}
              />
            </Tab>
          </Tooltip>
        ))}
      </TabGroup>
    </div>
  );
}
